var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProgressCheck = function SvgProgressCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "progress_check_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C600",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69C0AD",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-693 -242)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#progress_check_svg__a)",
    d: "M0 101h1441v309H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 120,
    y: 202,
    width: 1200,
    height: 411,
    rx: 15
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(693 242)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#C2C600",
    cx: 24.5,
    cy: 23.5,
    r: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13 24.5 7.563 7.5L35 17"
  })))));
};
export default SvgProgressCheck;